import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "That's Tuft Creative Co.";
const TITLES = {
  "/": `${BASE} | Rug Tufting Workshops`,
  "/workshops": "Book a Rug Tufting Workshop",
  "/themes": "Book by Theme",
  "/private-events": "Private Events & Parties",
  "/corporate": "Corporate & Mobile Events",
  "/custom-rugs": "Custom Rugs",
  "/patch-hat-bar": "Patch Hat Bar",
  "/tuft-buddies": "Tuft Buddies",
  "/community": "Community Arts Program",
  "/gift-cards": "Gift Cards",
  "/gallery": "Gallery",
  "/contact": "Contact",
};

export default function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = TITLES[pathname];
    document.title = t ? (pathname === "/" ? t : `${t} | ${BASE}`) : `${BASE} | Rug Tufting Workshops`;
  }, [pathname]);
  return null;
}
